import React from 'react';
import { Steps as AntSteps } from 'antd';
import styled from 'styled-components';
import { windowMaxWidth } from '../../ui/Layout/breakpoints';

const StyledSteps = styled(AntSteps)`
  &.ant-steps {
    .ant-steps-item {
      .ant-steps-item-container {
        .ant-steps-item-content {
          margin-top: -32px;

          .ant-steps-item-title {
            color: var(--greyscale-concrete);
            font-size: var(--font-size-small);
            font-weight: var(--font-weight-medium);
            letter-spacing: 0.5px;
            line-height: var(--font-line-height-small);
            text-transform: uppercase;
          }

          @media ${windowMaxWidth.mobile} {
            margin-top: 0 !important;
          }
        }
      }
    }

    .ant-steps-item-finish {
      .ant-steps-item-container {
        .ant-steps-item-content {
          .ant-steps-item-title {
            color: var(--primary-oqio-blue);
          }
        }
      }
    }

    .ant-steps-item-process {
      .ant-steps-item-container {
        .ant-steps-item-content {
          margin-top: -38px;

          .ant-steps-item-title {
            color: var(--primary-oqio-blue);
            font-weight: var(--font-weight-medium);
          }
        }
      }
    }
  }
`;

export const Steps = (props) => {
  return <StyledSteps {...props} />;
};
